module.exports = __webpack_public_path__ + "static/media/radio.3e1f4368.svg";